var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-footer"},[_vm._v("\n    广东省人民政府办公厅主办\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }